var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F6F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#253B80",
    d: "m19.579 35.186.416-2.642-.927-.021h-4.424l3.074-19.495a.251.251 0 0 1 .25-.213h7.46c2.477 0 4.186.515 5.078 1.532.418.477.685.976.814 1.525.135.575.137 1.263.005 2.102l-.01.062v.537l.42.237c.352.187.631.401.846.646.358.408.59.927.687 1.541.101.633.068 1.385-.098 2.237-.19.98-.499 1.833-.916 2.531a5.207 5.207 0 0 1-1.451 1.59 5.886 5.886 0 0 1-1.955.883c-.72.188-1.542.282-2.443.282h-.58c-.416 0-.82.15-1.136.418a1.758 1.758 0 0 0-.591 1.056l-.044.238-.735 4.656-.033.171c-.01.054-.024.081-.047.1a.123.123 0 0 1-.076.027H19.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#179BD7",
    d: "M32.13 18.098c-.022.142-.047.288-.076.437-.984 5.051-4.35 6.796-8.648 6.796h-2.189c-.526 0-.969.382-1.05.9l-1.121 7.107-.317 2.015a.56.56 0 0 0 .552.647h3.882c.46 0 .85-.334.923-.787l.038-.198.73-4.638.048-.254a.934.934 0 0 1 .922-.79h.58c3.762 0 6.706-1.526 7.567-5.945.36-1.846.173-3.387-.778-4.471a3.713 3.713 0 0 0-1.063-.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#222D65",
    d: "M31.102 17.687a7.792 7.792 0 0 0-.957-.212 12.15 12.15 0 0 0-1.93-.141H22.37a.93.93 0 0 0-.922.789L20.203 26l-.036.23c.082-.519.525-.9 1.05-.9h2.19c4.298 0 7.664-1.746 8.648-6.796.03-.15.054-.295.076-.438a5.24 5.24 0 0 0-.809-.34 7.151 7.151 0 0 0-.22-.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#253B80",
    d: "M21.446 18.123a.93.93 0 0 1 .922-.788h5.847c.693 0 1.34.045 1.93.14a7.808 7.808 0 0 1 1.178.28c.29.098.56.211.808.343.293-1.867-.002-3.138-1.012-4.289C30.007 12.542 28 12 25.43 12h-7.46c-.525 0-.973.382-1.054.901l-3.107 19.696c-.061.39.24.741.632.741h4.606l1.156-7.337 1.244-7.878Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalIcon);
export default __webpack_public_path__ + "static/media/paypalIcon.ea35083b73363f12fa7afe28ab66f151.svg";
export { ForwardRef as ReactComponent };